import React, { useCallback, useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';

import { DataGrid } from '../../Common';
import { text_commonCellProps, select_commonCellProps } from '../../Common/DataGrid/utils';
import { getDateRangeFilterOperator } from '../../Common/DataGrid/FilterComponents';
import { Grey2 } from '../../../color_utils';
import Routes from '../../../routes';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: 'registrationTypeName',
        headerName: 'Registration Type',
        ...select_commonCellProps,
    },
    {
        field: 'systemId',
        headerName: 'System ID',
        ...text_commonCellProps,
    },
    {
        field: 'effectiveDate',
        headerName: 'Effective Date',
        filterOperators: dateRangeFilterOperator,
        flex: 1,
        valueGetter: (_value, row) => row.effectiveDateString,
    },
    {
        field: 'endDate',
        headerName: 'End Date',
        filterOperators: dateRangeFilterOperator,
        flex: 1,
        valueGetter: (_value, row) => row.endDateString,
    },
    {
        field: 'notes',
        headerName: 'Notes',
        ...text_commonCellProps,
    },
];

const SystemRegistrationTable = ({
    assetId,
    refresh,
    handleEdit,
}) => {
    const [tableFilters, setTableFilters] = useState([]);

    const fetchFilters = useCallback(async () => {
        const response = await fetch(Routes.SystemRegistration.TableFilters());

        if (response.status === 200) {
            const data = await response.json();
            setTableFilters(data);
        }
    }, []);

    useEffect(() => {
        fetchFilters();
    }, [fetchFilters]);

    const rowActions = {
        type: 'actions',
        field: 'Quick Actions',
        width: 100,
        getActions: ({ row }) => [
            <GridActionsCellItem
                icon={
                    <Tooltip title="Edit Registration">
                        <EditIcon sx={{ color: Grey2 }} />
                    </Tooltip>
                }
                onClick={() => handleEdit(row)}
            />,
        ]
    };

    return (
        <>
            <DataGrid
                url={Routes.SystemRegistration.Table(assetId)}
                exportButtonURL={Routes.SystemRegistration.TableExport(assetId)}
                exportFileName="SystemRegistrations"
                noResultText="No system registrations found."
                noResultText2="Add a new system registration from the action menu."
                refresh={refresh}
                filterOptions={tableFilters}
                columns={[...columns, rowActions]}
            />
        </>
    );
};

export default SystemRegistrationTable;
